// ⚠️⚠️⚠️⚠️ AUTO GENERATED FILE ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
import fetchGraphqlClient from '@workspace/nextjs_utils/src/fetchGraphqlClient';
import useMutation, { type MutationOptions } from '../../useMutation';
import { ToggleMbtcMutationDocument, type ToggleMbtcMutation, type ToggleMbtcMutationVariables } from './ToggleMbtcMutation';

export async function getToggleMbtcMutationClient(variables: ToggleMbtcMutationVariables) {
  return fetchGraphqlClient<ToggleMbtcMutation, ToggleMbtcMutationVariables>(ToggleMbtcMutationDocument, "ToggleMbtcMutation", { variables });
}
export const useToggleMbtcMutation = (options?: MutationOptions) => useMutation<ToggleMbtcMutation, ToggleMbtcMutationVariables>(getToggleMbtcMutationClient, options);